import { useClientsState } from "atoms/clientsAtom";
import { ClientGroup } from "types";
import { useSetAtom } from "jotai/index";

import { Row } from "components/Row/Row";
import { Paragraph } from "components/Paragraph/Paragraph";

import { setClientGroupAtom } from "../../atoms/modalAtom/modalAtom";

import styles from "./styles.module.scss";
import { useGetClientGroups } from "./api";

export const ClientGroupBody = (): JSX.Element => {
  const { clientsState, setClientsState } = useClientsState();
  const { data: clientGroups = [] } = useGetClientGroups();
  const setClientGroupInfo = useSetAtom(setClientGroupAtom);

  const handleRowClick = (activeGroupItem: ClientGroup | null) => {
    if (
      activeGroupItem?.clientgroupid &&
      activeGroupItem?.clientgroupid ===
        clientsState.activeGroupItem?.clientgroupid
    ) {
      setClientGroupInfo(true);
    } else {
      setClientsState((prev) => ({
        ...prev,
        activeGroupItem,
        activeItems: [],
        activeItem: null
      }));
    }
  };

  return (
    <div className={styles.container}>
      <Row
        onClick={() => handleRowClick(null)}
        isActive={clientsState.activeGroupItem === null}
      >
        <Paragraph>Все</Paragraph>
      </Row>

      {clientGroups.map((group: ClientGroup) => (
        <Row
          key={group.clientgroupid}
          onClick={() => handleRowClick(group)}
          isActive={
            clientsState.activeGroupItem?.clientgroupid === group.clientgroupid
          }
        >
          <Paragraph>{group.name}</Paragraph>
        </Row>
      ))}
    </div>
  );
};
